var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "col ft-bld", class: { dsbld: _vm.tempDisable } },
    [
      _c(
        "router-link",
        {
          ref: "navItem",
          class: { active: _vm.Global.currentDashboardStep === 1 },
          attrs: { tag: "li", to: "/dashboard/homepage" },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.tabSwitch(0)
            },
          },
        },
        [
          _c("span", { staticClass: "ico" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "22",
                  height: "20",
                  viewBox: "0 0 22 20",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M7.535 1.92011L7.53499 1.92012L1.87636 6.86851C0.670333 7.92316 0.067318 8.45049 0.00954518 8.909C-0.0405105 9.30626 0.108372 9.70268 0.407563 9.96877C0.697128 10.2263 1.30715 10.2679 2.44125 10.2746V18.781C2.44125 19.452 2.98522 19.996 3.65625 19.996H7.70574C8.37677 19.996 8.92074 19.452 8.92074 18.781V14.7309C8.92074 14.0599 9.46472 13.5159 10.1357 13.5159H11.7557C12.4268 13.5159 12.9707 14.0599 12.9707 14.7309V18.781C12.9707 19.452 13.5147 19.996 14.1857 19.996H18.2362C18.9073 19.996 19.4513 19.452 19.4513 18.781V10.2746C20.587 10.2679 21.1977 10.2265 21.4875 9.96877C21.7867 9.70268 21.9356 9.30626 21.8855 8.909C21.8278 8.45049 21.2248 7.92316 20.0187 6.8685L14.3601 1.92011C13.1509 0.862714 12.5463 0.334014 11.866 0.132906C11.2665 -0.0443019 10.6286 -0.0443019 10.0291 0.132906C9.34875 0.334014 8.74417 0.862712 7.535 1.92011Z",
                    fill: "white",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [_vm._v("Homepage")]),
          _vm._v(" "),
          _c("span", {
            staticClass: "act-bg",
            style: {
              transform:
                "translateY(calc(" +
                100 * (_vm.Global.currentDashboardStep - 1) +
                "% + " +
                6 * (_vm.Global.currentDashboardStep - 1) +
                "px)",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          class: { active: _vm.Global.currentDashboardStep === 2 },
          attrs: { tag: "li", to: "/dashboard/contents" },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.tabSwitch(1)
            },
          },
        },
        [
          _c("span", { staticClass: "ico" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "19",
                  height: "22",
                  viewBox: "0 0 19 22",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M6.71172 20.6157C4.01977 22.4029 0.421599 20.4728 0.421599 17.2416V10.6536L0.421597 4.06562C0.421596 0.834394 4.01977 -1.0957 6.71171 0.691544L16.6346 7.27954C19.0478 8.8817 19.0478 12.4255 16.6346 14.0277L6.71172 20.6157Z",
                    fill: "white",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [_vm._v("Contents")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "mny",
          class: { active: _vm.Global.currentDashboardStep === 3 },
          attrs: { tag: "li", to: "/dashboard/monetization" },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.tabSwitch(2)
            },
          },
        },
        [
          _c("span", { staticClass: "ico" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "16",
                  height: "25",
                  viewBox: "0 0 16 25",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M9.72 0H6.72V2.28843C5.86089 2.39971 5.06678 2.61601 4.33766 2.93734C3.22226 3.42891 2.34453 4.11268 1.70444 4.98867C1.0707 5.86466 0.756996 6.88875 0.763333 8.06094C0.756996 9.49151 1.22914 10.629 2.17975 11.4735C3.13037 12.318 4.42638 12.9387 6.06778 13.3358L6.72 13.4987V18.5239C6.51675 18.4764 6.32152 18.4171 6.13432 18.3459C5.57663 18.1254 5.12984 17.8008 4.79395 17.3723C4.4644 16.9374 4.27745 16.3954 4.23309 15.7463H0.25C0.281687 17.1391 0.620741 18.3081 1.26716 19.2534C1.91992 20.1924 2.82617 20.9014 3.98593 21.3804C4.79875 21.7142 5.71011 21.9317 6.72 22.0329V24.2H9.72V22.0062C10.6249 21.8971 11.4355 21.6917 12.1517 21.3898C13.2798 20.9109 14.1417 20.2397 14.7374 19.3763C15.3395 18.5066 15.6437 17.4794 15.65 16.2946C15.6437 15.4879 15.4947 14.7727 15.2032 14.1488C14.918 13.5248 14.5156 12.9829 13.9959 12.5228C13.4763 12.0628 12.8615 11.6752 12.1517 11.3601C11.4419 11.045 10.6624 10.7929 9.81321 10.6038L9.72 10.5817V5.86802C9.99579 5.96717 10.2423 6.09629 10.4596 6.25539C11.0363 6.67763 11.3627 7.27003 11.4388 8.03258H15.3838C15.3648 6.8793 15.0543 5.86466 14.4522 4.98867C13.8502 4.11268 13.0073 3.42891 11.9236 2.93734C11.259 2.63412 10.5245 2.42441 9.72 2.30824V0ZM6.72 5.79764C6.61192 5.82934 6.50859 5.86534 6.41 5.90563C5.94737 6.08839 5.59247 6.34362 5.34531 6.67133C5.10449 6.99904 4.98407 7.37086 4.98407 7.7868C4.9714 8.13341 5.04428 8.43591 5.20272 8.6943C5.36749 8.95268 5.59247 9.17641 5.87766 9.36547C6.12505 9.52401 6.40583 9.66596 6.72 9.7913V5.79764ZM9.72 14.3257V18.4168C9.76766 18.4003 9.81457 18.383 9.86074 18.3648C10.3804 18.1632 10.7828 17.8827 11.068 17.5235C11.3532 17.1643 11.4958 16.7515 11.4958 16.2852C11.4958 15.8503 11.3659 15.4848 11.1061 15.1886C10.8526 14.8924 10.4786 14.6403 9.98432 14.4323C9.89956 14.3962 9.81145 14.3607 9.72 14.3257Z",
                    fill: "white",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [_vm._v("Monetization")]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "stgs",
          class: { active: _vm.Global.currentDashboardStep === 4 },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.tabSwitch(3)
            },
          },
        },
        [
          _c("span", { staticClass: "ico" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "22",
                  height: "23",
                  viewBox: "0 0 22 23",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M7.51017 2.88C7.51017 1.87191 7.51017 1.36786 7.70636 0.982817C7.87893 0.644125 8.1543 0.36876 8.49299 0.196188C8.87803 0 9.38208 0 10.3902 0H10.9302C11.9383 0 12.4423 0 12.8274 0.196188C13.166 0.36876 13.4414 0.644125 13.614 0.982817C13.8102 1.36786 13.8102 1.87191 13.8102 2.88V3.29896C14.5931 3.6094 15.3193 4.03213 15.9688 4.54729L16.333 4.33703C17.2061 3.83298 17.6426 3.58096 18.0741 3.55834C18.4537 3.53845 18.8299 3.63924 19.1487 3.84627C19.5111 4.08163 19.7631 4.51814 20.2672 5.39118L20.5372 5.85884C21.0412 6.73187 21.2933 7.16839 21.3159 7.59994C21.3358 7.97954 21.235 8.35569 21.028 8.67449C20.7926 9.03692 20.3561 9.28894 19.483 9.79299L19.1198 10.0027C19.1794 10.4098 19.2102 10.8263 19.2102 11.25C19.2102 11.6737 19.1793 12.0903 19.1198 12.4975L19.4828 12.707C20.3559 13.2111 20.7924 13.4631 21.0277 13.8255C21.2348 14.1443 21.3356 14.5205 21.3157 14.9001C21.293 15.3316 21.041 15.7682 20.537 16.6412L20.267 17.1088L20.267 17.1089C19.7629 17.9819 19.5109 18.4184 19.1485 18.6538C18.8297 18.8608 18.4535 18.9616 18.0739 18.9417C17.6424 18.9191 17.2059 18.667 16.3328 18.163L15.9687 17.9528C15.3192 18.4679 14.5931 18.8906 13.8102 19.201V19.62C13.8102 20.6281 13.8102 21.1321 13.614 21.5172C13.4414 21.8559 13.166 22.1312 12.8274 22.3038C12.4423 22.5 11.9383 22.5 10.9302 22.5H10.3902C9.38208 22.5 8.87803 22.5 8.49299 22.3038C8.1543 22.1312 7.87893 21.8559 7.70636 21.5172C7.51017 21.1321 7.51017 20.6281 7.51017 19.62V19.201C6.72699 18.8905 6.00059 18.4676 5.35086 17.9522L4.98577 18.163C4.11274 18.667 3.67622 18.9191 3.24467 18.9417C2.86507 18.9616 2.48891 18.8608 2.17012 18.6537C1.80769 18.4184 1.55567 17.9819 1.05162 17.1088L0.781619 16.6412C0.277572 15.7681 0.0255488 15.3316 0.00293223 14.9001C-0.0169618 14.5205 0.0838287 14.1443 0.290858 13.8255C0.52622 13.4631 0.962737 13.2111 1.83577 12.707L2.20039 12.4965C2.14095 12.0896 2.11017 11.6734 2.11017 11.25C2.11017 10.8267 2.14094 10.4105 2.20037 10.0036L1.83555 9.793C0.962517 9.28895 0.525999 9.03693 0.290638 8.6745C0.0836084 8.35571 -0.0171822 7.97955 0.00271185 7.59995C0.0253284 7.1684 0.277352 6.73188 0.781399 5.85885L1.0514 5.39119C1.55545 4.51816 1.80747 4.08164 2.16989 3.84628C2.48869 3.63925 2.86485 3.53846 3.24445 3.55835C3.676 3.58097 4.11252 3.83299 4.98555 4.33704L5.35075 4.54789C6.0005 4.03246 6.72694 3.60952 7.51017 3.29896V2.88ZM10.6602 15.3C12.8969 15.3 14.7102 13.4868 14.7102 11.25C14.7102 9.01325 12.8969 7.2 10.6602 7.2C8.42342 7.2 6.61017 9.01325 6.61017 11.25C6.61017 13.4868 8.42342 15.3 10.6602 15.3Z",
                    fill: "white",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text" }, [_vm._v("Settings")]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }